<template>
  <div class="main-button">
    <cus-button
      text="備註"
      color="whiteBlue"
      :leftIcon="getNote ? 'check-circle-fill' : ''"
      leftIconClass="green-icon"
      :disabled="!getCanEdit.note"
      :style="isInView ? 'grid-area: 1/1/2/3' : ''"
      @click="openDialog('itemNote')"
    ></cus-button>
    <cus-button
      text="折扣"
      color="whiteBlue"
      :leftIcon="chooseDiscount && chooseDiscount?.length > 0 ? 'check-circle-fill' : ''"
      leftIconClass="green-icon"
      :disabled="!getCanEdit.discount"
      :style="isInView ? 'grid-area: 1/3/2/5' : ''"
      @click="openDialog('discount')"
    ></cus-button>
    <cus-button
      v-if="!isInView"
      :text="`${getItemId ? '儲存' : '加入'}並新增同項`"
      color="whiteBlue"
      style="grid-area: 1/3/2/5"
      :disabled="!getDetail.size || !getDetail.temperature || !getDetail.sweetness || (getItemId && !getIsEdit)"
      @click="handleCartItemPreScript('copy')"
    ></cus-button>
    <cus-button :text="isInView ? '返回' : '取消選擇'" color="green-border" @click="close"></cus-button>
    <cus-button
      :text="`${getItemName} ${getItemPrice ? `$${(getItemPrice + getAddonsCharge) * chooseQuantity}` : ''}`"
      textClass="item-name-text"
      color="weekGreen"
      :isButton="false"
      style="grid-area: 2/2/3/5"
    ></cus-button>
    <cus-button
      :text="getItemId ? '儲存' : '加入'"
      color="blue"
      :topIcon="getItemId ? 'check2-square' : 'plus-square'"
      topIconClass="big-top"
      style="grid-area: 1/5/3/6"
      :disabled="!getDetail.size || !getDetail.temperature || !getDetail.sweetness || (getItemId && !getIsEdit)"
      @click="handleCartItemPreScript('noCopy')"
    ></cus-button>
  </div>
  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useDialog } from '@/utils/dialog';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import {defineAsyncComponent, getCurrentInstance, watch} from 'vue';

export default {
  name: 'menu-button',
  components: {
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
    InputInfo: defineAsyncComponent(() => import('@/components/dialog/InputInfo.vue')),
  },
  props: ['isInView'],
  emits: ['closeDetail'],
  computed: {

  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得品項相關清單
    const {
      getMenuItem,
      chooseDiscount,
      chooseQuantity,
      getNote,
      getItemName,
      getDetail,
      getItemId,
      getItemPrice,
      getCanEdit,
      getIsEdit,
      getAddonsCharge,
    } = useGetters('menuItem', [
      'getMenuItem',
      'chooseDiscount',
      'chooseQuantity',
      'getNote',
      'getItemName',
      'getDetail',
      'getItemId',
      'getItemPrice',
      'getCanEdit',
      'getIsEdit',
      'isMenuDetail',
      'getAddonsCharge',
    ]);

    //監聽品項內容有更動
    const SET_IS_EDIT = useMutations('menuItem', ['SET_IS_EDIT']);
    watch(
      getMenuItem,
      (content, prevContent) => {
        if (getItemId.value && content.item_id === prevContent.item_id) {
          SET_IS_EDIT(true);
        }
      },
      { deep: true }
    );

    //處理彈窗動作
    const { SET_NOTE, SET_DISCOUNT, SET_PRINT_LABEL } = useMutations('menuItem', ['SET_NOTE', 'SET_DISCOUNT', 'SET_PRINT_LABEL']);
    const handleNote = (val) => {
      SET_NOTE(val);
      closeDialog();
    };
    const handleDiscount = (val) => {
      //折扣此階段先做單選介面，但資料以多選(array)處理
      let data = [];
      if (!val) val = [];
      if (!Array.isArray(val) && val) data.push(val.value || val);
      else {
        val.forEach((e) => {
          data.push(e.value || e);
        });
      }
      SET_DISCOUNT(data);
      closeDialog();
    };

    //加入或儲存品項
    const doHandleCartItem = useActions('cart', ['doHandleCartItem']);
    const chooseItem = useGetters('menuItem', ['chooseItem']);
    const posConfig = useGetters('system', ['getConfig']);
    const { doCancelItem, doSetItem } = useActions('menuItem', ['doCancelItem', 'doSetItem']);
    const handleCartItemPreScript = async (action) => {
      // console.log('getMenuItem', getMenuItem.value.quantity);
      // console.log('posConfig', posConfig.value);
      let quantity = getMenuItem.value.quantity;
      let productName = getMenuItem.value.item.label;
      let itemQuantityAlertThreshold = posConfig.value.setting.item_quantity_alert.threshold; //超過幾個數量要跳alert
      let itemQuantityAlertEnable = posConfig.value.setting.item_quantity_alert.enable; //超過幾個數量要跳alert

      // console.log('quantity', quantity, 'itemQuantityAlertThreshold', itemQuantityAlertThreshold);
      if ( itemQuantityAlertEnable && quantity > itemQuantityAlertThreshold) { //超過設定的數量，
        proxy.$confirm({
          content: '【' + productName + '】輸入的數量為【' + quantity + '】' +
              '<br/>請確認數量是否正確',
          confirmText: '是',
          cancelText:'否'
        }).then(() => { //是，要印貼紙
          console.log('then')
          handleCartItem(action, true);
        }).catch((e) => { //否 不印貼紙
          console.log(e);
          // handleCartItem(action, false);
        });
      }
      else {
        await handleCartItem(action, true);
      }
    }
    const handleCartItem = async (action, isPrintLabel = true) => {
      try {
        SET_PRINT_LABEL(isPrintLabel);
        await doHandleCartItem(action);
        //加入(儲存)
        if (action === 'noCopy') {
          console.log(action, 'noCopy');
          doCancelItem();
        }
        //加入(儲存)並新增同項
        else {
          const item = chooseItem.value;
          doCancelItem();
          doSetItem(item);
        }
        //瀏覽內的編輯品項
        if (props.isInView) context.emit('closeDetail');
      } catch (e) {
        return false;
      }
    };

    //取消或返回
    const close = () => {
      doCancelItem();
      context.emit('closeDetail');
    };
    return {
      dialogTemplate,
      openDialog,
      chooseDiscount,
      chooseQuantity,
      getNote,
      getItemName,
      getDetail,
      getItemId,
      getItemPrice,
      getCanEdit,
      getIsEdit,
      getAddonsCharge,
      doCancelItem,
      handleNote,
      handleDiscount,
      handleCartItem,
      handleCartItemPreScript,
      close,
    };
  },
};
</script>
<style lang="scss" scoped>
.main-button {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
}
:deep(.item-name-text) {
  -webkit-line-clamp: 1;
}
</style>
